import { toast } from 'sonner'

import { useGetPayrollManageConfig } from 'utils/web_api'

export function useParterManagedPayrollError () {
  const { data: payrollConfig } = useGetPayrollManageConfig()
  const providerName = payrollConfig?.provider_display_name ?? 'your payroll provider'

  return {
    showPartnerManagedError: (errorString?: string) => toast.error(`${errorString ?? 'Error'}: payroll is managed by ${providerName}`)
  }
}
